import { useState } from 'react';
export function useMaxOutlets({
  defaultMaxOutlets,
}: {
  defaultMaxOutlets?: string
}) {
  const [maxOutlets, setMaxOutlets] = useState<string>(defaultMaxOutlets || '')

  const onChangeMaxOutlets = (str: string) => {
    setMaxOutlets(str)
  }
  return {
    maxOutlets,
    onChangeMaxOutlets,
  }
}
